import React from 'react';
import PuffLoader from 'react-spinners/PuffLoader';

import {theme} from '../constants';

export const TabLoader: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.ghostWhite,
        position: 'absolute',
        inset: 0,
        top: 56,
        bottom: 64,
      }}
    >
      <PuffLoader
        size={38}
        color={theme.colors.mainColor}
        aria-label='Loading Spinner'
        data-testid='loader'
        speedMultiplier={0.9}
      />
    </div>
  );
};
